export default [
    {
        path: '/liveRoom/paidTips',
        name: 'paidTips',
        component: () => import("../views/liveRoom/paidTips.vue")
    },
    {
        path: '/liveRoom/publishPackage',
        name: 'publishPackage',
        component: () => import("../views/liveRoom/publishPackage.vue")
    },
    {
        path: '/liveRoom/share',
        name: 'publishShare',
        component: () => import("../views/liveRoom/shareExpert.vue")
    }
]
